import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IComboBase } from '../interfaces/base/base.interface';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContinuityContractsService {
  private apiUrl = `${environment.apiUrl}/continuityContracts`;

  constructor(private http: HttpClient) {}

  comboContinuityContracts(): Observable<IComboBase[]> {
    return this.http.get<IComboBase[]>(this.apiUrl + '/combo');
  }
}
